<div class="wrap">
  <div *ngIf="orders?.length! > 0" class="content">
    <div class="list">
      <div
        class="order-item"
        *ngFor="let order of orders"
        (click)="goToOrderDetails(order.id)"
        [class.delivered]="
          (order | getOrderStatus) === orderStatuses.DELIVERED ||
          (order | getOrderStatus) === orderStatuses.CONFIRMED ||
          (order | getOrderStatus) === orderStatuses.PICKED_UP
        "
        [class.pending]="
          (order | getOrderStatus) === orderStatuses.PENDING ||
          (order | getOrderStatus) === orderStatuses.REFUNDED ||
          (order | getOrderStatus) === orderStatuses.AWAITING_PAYMENT
        "
        [class.error]="(order | getOrderStatus) === orderStatuses.PAYMENT_ERROR"
      >
        <app-order-list-item-header
          [order]="order"
        ></app-order-list-item-header>

        <div class="item-list">
          <div *ngIf="order.type === orderTypes.DELIVERY" class="by-days">
            <div class="day" *ngFor="let day of getOrderDeliveryDays(order)">
              <div class="order-item-list in-store-list">
                <ng-container
                  *ngFor="
                    let orderItem of order.items
                      | filterOrderItemsByDay : day
                      | async
                  "
                >
                  <app-order-item
                    [label]="orderItem.item.name"
                    [price]="orderItem.prices | getPrimaryCurrencyPrice"
                    [amount]="orderItem.quantity"
                  ></app-order-item>

                  <app-order-list-item-status
                    [order]="order"
                    [orderItem]="orderItem"
                  ></app-order-list-item-status>
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="order.type === orderTypes.IN_STORE" class="">
            <div class="order-item-list">
              <ng-container *ngFor="let orderItem of order.items">
                <app-order-item
                  [label]="orderItem.item.name"
                  [price]="orderItem.prices | getPrimaryCurrencyPrice"
                  [amount]="orderItem.quantity"
                ></app-order-item>
                <app-order-list-item-status
                  [order]="order"
                  [orderItem]="orderItem"
                ></app-order-list-item-status>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="orders?.length === 0" class="empty-message">
    <div class="icon"></div>
    <div class="message">
      {{ "@components.orderList.emptyListMessage" | translate }}
    </div>
  </div>
  <div *ngIf="orders === null" class="spinner">
    <ion-spinner class="app-spinner"></ion-spinner>
  </div>
</div>
